import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Box, styled } from '@mui/material'
import { AlertProps, Button } from '@carto/meridian-ds/components'
import { createDialogOpener } from 'features/dialogs/openDialog'
import { NotificationActions as NotificationAction } from 'features/notifications/state/notificationSlice'

const ActionWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'light'
})<{ light?: boolean }>(({ theme, light }) => ({
  '& + .MuiBox-root': {
    marginLeft: theme.spacing(1)
  },

  ...(light && {
    '.MuiButton-root': {
      color: theme.palette.common.white,
      borderColor: theme.palette.common.white,

      '&:hover, &:focus-visible': {
        backgroundColor: theme.palette.white[8]
      }
    }
  })
}))

interface NotificationActionsProps {
  action?: NotificationAction
  error?: unknown
  severity?: AlertProps['severity']
}

const openErrorDialog = createDialogOpener(() => import('features/common/ui/ErrorDialog/ErrorDialog'))

function NotificationActions({ action, error, severity }: NotificationActionsProps) {
  const intl = useIntl()
  const showErrorDialog = () => {
    openErrorDialog({
      simple: true,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: TS2322
      error,
      title: intl.formatMessage({ id: 'common.notifications.errorDetails' })
    })
  }
  const isErrorType = severity === 'error'

  if (action?.type === 'button') {
    return (
      <ActionWrapper light={isErrorType}>
        <Button color="secondary" variant={action.variant} href={action.link} target="_blank" rel="noopener noreferrer">
          <FormattedMessage id={action.labelId} />
        </Button>
      </ActionWrapper>
    )
  }

  if (error) {
    return (
      <ActionWrapper light={isErrorType}>
        <Button variant="text" onClick={showErrorDialog}>
          <FormattedMessage id={action?.labelId || 'common.button.viewDetails'} />
        </Button>
      </ActionWrapper>
    )
  }

  if (action) {
    return (
      <ActionWrapper light={isErrorType}>
        <Button color="secondary" variant={action.variant} component={Link} to={action.link}>
          <FormattedMessage id={action.labelId} />
        </Button>
      </ActionWrapper>
    )
  }

  return null
}

export default NotificationActions
